var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"own-box display-flex flex-wrap text-align-center"},_vm.$listeners),[_c('div',{staticClass:"flex-center--end flex-col-12"},[_c('SIcon',{attrs:{"name":"plus-create-new"}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col-12"},[_c('h3',{staticClass:"reg"},[_vm._v("Create your own")])])
}]

export { render, staticRenderFns }